import { render, staticRenderFns } from "./ppmexport.vue?vue&type=template&id=bc30e3c0&scoped=true&"
import script from "./ppmexport.vue?vue&type=script&lang=ts&"
export * from "./ppmexport.vue?vue&type=script&lang=ts&"
import style0 from "./ppmexport.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ppmexport.vue?vue&type=style&index=1&id=bc30e3c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc30e3c0",
  null
  
)

component.options.__file = "ppmexport.vue"
export default component.exports